export default class ParameterValue {
  constructor(code, value, level_type, level, sname, pname, unit) {
    this.code = code;
    this.value = value;
    this.level_type = level_type;
    this.level = level;
    this.sname = sname;
    this.pname = pname;
    this.unit = unit;
  }

}
